import { __rest, __assign } from '../../../../node_modules/tslib/tslib.es6.js';
import React, { useContext } from 'react';
import { DialogContent } from './style.js';
import { DialogContext } from './DialogContext.js';

var DialogBody = function DialogBody(_a) {
  var children = _a.children,
      rest = __rest(_a, ["children"]);

  var dialogState = useContext(DialogContext).dialogState;
  return /*#__PURE__*/React.createElement(DialogContent, __assign({
    theme: dialogState.theme
  }, rest), children);
};

export { DialogBody };